import "./DigitalMapsCreationAndUpdate.module.css";
import Header from "@/reusable_sections/Header";
import ContactSection from "./sections/ContactSection";
import GeospatialHeroComparison from "./sections/GeospatialHeroComparison";
import Footer from "@/reusable_sections/Footer";
export default function DigitalMapsCreationAndUpdatePage() {
  return <div>
      <Header />
      <GeospatialHeroComparison />
      <ContactSection />
      <Footer />
    </div>;
}